import {
  ENDPOINTS,
  SetPartyRegionRequestSchema,
  type SetPartyRegionRequest,
  type SetPartyRegionResponse,
} from '@clm/shared-types';

import { apiPost } from './client';

/**
 * `set-party-region` — CLM-87 / D-87-10, the admin override on a client's region.
 *
 * Verification places a client once, from the first verified counterparty
 * country (D-87-9); this call places one the table could not (*Unassigned*),
 * moves one, or clears it (`region: null`) so the next verified contract places
 * it again. The body is validated `.strict()` before anything is sent; the
 * response is parsed, not asserted, and carries the audit receipt of the
 * `party` UPDATE (rule 7). The control is never disabled by role — a 403 from
 * the API renders the surface's problem copy (CLM-82).
 */
const SET_REGION = ENDPOINTS['set-party-region'];

export async function setPartyRegion(
  request: SetPartyRegionRequest,
  signal?: AbortSignal,
): Promise<SetPartyRegionResponse> {
  const body = SetPartyRegionRequestSchema.parse(request);
  const { party_key, ...rest } = body;
  const path = SET_REGION.path.replace('{party_key}', encodeURIComponent(party_key));
  const raw = await apiPost<unknown>(path, rest, signal === undefined ? {} : { signal });
  return SET_REGION.response.parse(raw);
}
